import { render, staticRenderFns } from "./ClinicalUnitDetails.vue?vue&type=template&id=3250147d&scoped=true"
import script from "./ClinicalUnitDetails.vue?vue&type=script&lang=js"
export * from "./ClinicalUnitDetails.vue?vue&type=script&lang=js"
import style0 from "./ClinicalUnitDetails.vue?vue&type=style&index=0&id=3250147d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3250147d",
  null
  
)

export default component.exports